import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServicoConexaoTerminal implements OnDestroy {
  private readonly estadoOnline = new BehaviorSubject<boolean>(navigator.onLine);
  private readonly ultimaConexaoOnline = new BehaviorSubject<Date | null>(navigator.onLine ? new Date() : null);
  readonly online$ = this.estadoOnline.asObservable();
  readonly ultimaConexaoOnline$ = this.ultimaConexaoOnline.asObservable();

  private readonly aoFicarOnline = () => {
    this.estadoOnline.next(true);
    this.ultimaConexaoOnline.next(new Date());
  };
  private readonly aoFicarOffline = () => this.estadoOnline.next(false);

  constructor() {
    window.addEventListener('online', this.aoFicarOnline);
    window.addEventListener('offline', this.aoFicarOffline);
  }

  get online() {
    return this.estadoOnline.value;
  }

  get ultimaConexao() {
    return this.ultimaConexaoOnline.value;
  }

  ngOnDestroy() {
    window.removeEventListener('online', this.aoFicarOnline);
    window.removeEventListener('offline', this.aoFicarOffline);
  }
}
